<script>
import CommonService from '@/services/common';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericBooleanDropdown from '@/components/generic/GenericBooleanDropdown.vue'

export default {
    props: ['configuration', 'category', 'name'],
    emits: ['onOpenCloneAggregationClick', 'onNodeSelect', 'onFilterSelected'],
    components: {GenericCustomMasterDataAutocompleteV2, GenericBooleanDropdown},
    data() {
        return {
            items: [],
            loading: false,
            params: {
                start: 0,
                limit: 10000,
                sort: null,
                filter: ''
            },
            globalFilter: null,
            expandedKeys: {},
            addNodeDialogVisible: false,
            selectedKey: null,
            selectedNode: null,
            newNode: {},
            selectedHeaderField: null,
            parentNode: null
        }
    },
    mounted() {
        if(!this.configuration.filterApi){
            this.loadData();
        }
    },
    computed: {
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        loadData(){
            this.items = [];
            this.loading = true;
            CommonService.loadGeneric(this.configuration.api, this.params, response => {
                this.loading = false;
                if(response.success){
                    this.items = this.generateTree(response.data);
                    this.total = response.totalCount;
                }else{
                    this.items = [];
                    this.total = 0;
                }

            });
        },
        generateTree(list) {
            var map = {}, node, roots = [], i;
            
            for (i = 0; i < list.length; i++) {
                map[list[i].id] = i; // initialize the map
                list[i].children = []; // initialize the children
            }
            
            for (i = 0; i < list.length; i++) {
                node = list[i];
                node.key = i;
                node.data = {...list[i]}
                if (node[this.configuration.parentIdColumn]) {
                    list[map[node[this.configuration.parentIdColumn]]].children.push(node);
                } else {
                    roots.push(node);
                }
            }
            return roots;
        },
        onFilterSelect(item){
            this.$emit('onFilterSelected', item)
            let filters = [
                {
                    operator: 'eq',
                    value: item.value,
                    property: this.configuration.filterField
                }
            ];

            if(this.configuration.headerField){
                this.selectedHeaderField = item.value;
            }

            this.params.filter = JSON.stringify(filters);
            this.loadData()
        },
        onAdd(){
            this.newNode = {};

            if(this.selectedNode == null){
                this.newNode.isRoot = true;
                if(this.configuration.headerField){
                    this.newNode[this.configuration.headerField] = this.selectedHeaderField;
                }
                this.newNode.livello = 1;
            }else{
                this.newNode.isRoot = false;
                if(this.configuration.headerField){
                    this.newNode[this.configuration.headerField] = this.selectedNode[this.configuration.headerField];
                }
                this.newNode[this.configuration.parentIdColumn] = this.selectedNode.id;
                this.newNode.livello = this.selectedNode.livello + 1;
            }
            
            this.addNodeDialogVisible = true;
        },
        onUpdate(){
            this.newNode = {...this.selectedNode};
            this.addNodeDialogVisible = true;
        },
        onNodeSelect(node){
            this.selectedNode = {...node};
            this.parentNode = this.selectedNode[this.configuration.parentLabelColumn]
            this.$emit('onNodeSelect', {...node})
        },
        addNode(){

            let item = {...this.newNode};
            // if(this.configuration.headerField){
            //     item[this.configuration.headerField] = this.selectedNode[this.configuration.headerField];
            // }
            // item[this.configuration.parentIdColumn] = this.selectedNode.id;
            // item.livello = this.selectedNode.livello + 1;
            CommonService.createItem(this.configuration.api, item, response => {
                if(response.success){
                    this.loadData();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })

            this.addNodeDialogVisible = false;
        },
        onDelete(){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    CommonService.deleteItem(this.configuration.api, this.selectedNode.id, response => {
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                            this.loadData();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
        }
    }
}
</script>

<template>
    <main>
        <Dialog v-model:visible="addNodeDialogVisible" :style="{width: '50vw'}" :modal="true" v-if="configuration && configuration.enableInsert && uiPermissions(configuration.addButtonName).isEnabled"
            :header="$t('btn.addNode')">
            <div class="grid">
                <div class="col-12 lg:col-3">
                    <label>{{$t('parent')}}</label>
                    <InputText v-model="parentNode" class="w-full" readonly />
                </div>
                <div class="col-12 lg:col-3" v-for="col in configuration.columns" :key="col.name">
                    <label>{{$t(col.label)}}</label>
                    <GenericBooleanDropdown
                        v-if="col.type == 'boolean'"
                        v-model="newNode[col.name]" 
                        :class="{'w-full': true}" />
                    <InputNumber 
                        v-if="col.type == 'number'"
                        v-model="newNode[col.name]" 
                        :class="{'w-full': true}" /> 
                    <InputText 
                        v-if="col.type=='string'"
                        v-model="newNode[col.name]" 
                        :class="{'w-full': true}" />
                    <GenericCustomMasterDataAutocompleteV2
                        v-if="col.type=='select'"
                      v-model="newNode[col.name]"
                      name="products" 
                      api="masterdata/product-combo"
                      :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                </div>
            </div>
            <template #footer>
                <Button :label="$t('btn.cancel')" text severity="secondary" @click="addNodeDialogVisible = false" autofocus />
                <Button :label="$t('btn.add')" outlined severity="secondary" @click="addNode" autofocus icon="pi pi-plus" />
            </template>
        </Dialog>
        <div class="card">
            <TreeTable :value="items" :loading="loading"
            scrollable scrollHeight="70vh" responsiveLayout="'scroll'"
                v-model:selectionKeys="selectedKey" selectionMode="single" @node-select="onNodeSelect">
                <template #header>
                    <div class="grid">
                        <div class="col-12 lg:col-3" v-if="configuration.filterApi">
                            <label>{{$t(configuration.filterLabel)}}</label>
                            <GenericCustomMasterDataAutocompleteV2
                                :name="configuration.filterApi"
                                v-model="globalFilter"
                                :changeFn="onFilterSelect"
                                :api="configuration.filterApi"/>
                        </div>
                        <div class="col-12 lg:col-9 mt-4">
                            <Button :label="$t('btn.addNode')" icon="pi pi-plus" class="p-button-sm mr-2" @click="onAdd" v-if="configuration && configuration.enableInsert && uiPermissions(configuration.addButtonName).isEnabled" />
                            <Button :disabled="!selectedNode" :label="$t('btn.edit')" icon="pi pi-pencil" class="p-button-sm mr-2" @click="onUpdate" v-if="configuration && configuration.enableInsert && uiPermissions(configuration.addButtonName).isEnabled" />
                            <Button :disabled="!selectedNode" :label="$t('btn.delete')" icon="pi pi-trash" class="p-button-sm mr-2 p-button-danger" @click="onDelete" v-if="configuration && configuration.enableDelete && uiPermissions(configuration.deleteButtonName).isEnabled" />
                            <span v-if="configuration">
                            <span v-for="btn in configuration.toolbarActions" :key="btn.name">
                                <Button v-if="(!uiPermissions(btn.name).isHidden) && btn.type == 'button'" :label="$t(btn.title)" :icon="btn.icon"  class="mr-2" :class="btn.cssClass" @click="btn.action(selectedItem, this)" :disabled="(typeof btn.disabled === 'function' ? btn.disabled(selectedItem, this) : false)  || !uiPermissions(btn.name).isEnabled"/>
                            </span>
                        </span>
                        </div>
                    </div>
                </template>


                <Column v-for="col in configuration.columns" :key="col.name" :field="col.name" :header="$t(col.label)" :expander="col.name == configuration.expanderKey">
                    <template #body="{ node}">
                        <span v-if="col.type=='boolean'">
                            <i class="pi" :class="{'text-green-400 pi-check': node[col.name]}" ></i>
                        </span>
                        <span v-else>
                            {{ node[col.name] }}
                        </span>
                    </template>
                </Column>
            </TreeTable>
        </div>
    </main>
</template>